import React, { Component } from 'react';
import {
  CardContainer,
  CardWrapper,
  CardHeader,
  ElementTitle,
  ElementTitleWrapper,
  HeaderButtons,
  HeaderBtn,
  CardBody,
  BodyInfo,
  NomCapa,
  InfoDesc,
  CardFooter,
  LeftButtons,
  RightButtons,
  InfoCardButton,
  NomParametre,
  Parametre,
  InfoPuntCardSVG,
  Link,
  SVGNewTab,
  CardEditButtonWrapper
} from './InformacioPuntCardElement';

import { zoomMapToBBOX } from '../Utils/MapUtils';
import { config } from '../../config/Config';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import { checkUrl, isDeepEqual, replaceHTTPWithHTTPS, urlNameSelector } from '../Utils/FormatUtils';
import { FavButton } from './InformacioPuntElement';
import { deleteFeature } from '../Utils/EdicioCapaUtils';
import { Text } from '../Llegenda/CapaLlegenda/CapaLlegendaFooter/Components/Editar/EditElement';
import { generarURLExtension } from '../Llegenda/CapaLlegenda/CapaLlegendaFooter/Components/Export/ExportLayerUtils';
import { displayComponents } from '../Utils/VisorsUtils';
import { ButtonStyle } from '../Navbar/Compartir/Componentes/Download/Load/LocalMaps/LocalMapsElement';

export default class InformacioPuntCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toolTip: undefined,
      isLocationHovered: false,
      isKMLHovered: false,
      isCSVHovered: false,
      isGMLHovered: false,
      isSHPHovered: false,
      photos: []
    };
  }

  componentDidMount() {
    this.obtenirAtributs();
    if (this.props.selected && !this.props.isEditing.isEditing && !this.props.isRaster) {
      this.props.setFotos({ layer: undefined, fotos: [] });
      this.props.featureOverlay.getSource().clear();
      this.props.featureOverlay.getSource().addFeature(this.props.feature);
    } else if (this.props.isEditing.isEditing) {
      this.props.featureOverlay.getSource().clear();
    }
    if (displayComponents.galeria) {
      Object.entries(this.props.info).forEach(([key, value]) => {
        if (checkUrl(value)) {
          if (value.endsWith('.jpg') || value.endsWith('.png') || value.endsWith('.JPG') || value.endsWith('.PNG')) {
            this.setState(
              (prevState) => ({
                photos: [...prevState.photos, value]
              }),
              () => {
                if (this.props.selected && !this.fotoCheck()) {
                  this.props.setFotos({ layer: this.props.nomCapa, fotos: this.state.photos });
                }
              }
            );
          }
        }
      });
    }
  }

  fotoCheck = () => {
    if (this.state.photos.length !== this.props.prevFotos.length) return false;
    if (this.state.photos == null || this.props.prevFotos == null) return false;

    for (let i = 0; i < this.state.photos.length; ++i) {
      if (this.state.photos[i] !== this.props.prevFotos[i]) return false;
    }
    return true;
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.selected === this.props.selected) {
    }
  };

  photoClick = async () => {
    await this.props.setFotos({ layer: this.props.nomCapa, fotos: this.state.photos });
    if (window.innerWidth < 768) {
      this.props.toggleGaleria(true);
    } else {
      this.props.tableInfoToggle('thumbnails');
    }
  };

  construirURLExport = (feature, layer, type) => {
    let url = '';
    let booleanSecure = false;
    let reg = new RegExp('/owsseg|owssec/');
    let onlineResource = layer.getOnlineResource();
    if (onlineResource !== null && onlineResource !== undefined) {
      let n = onlineResource.match(reg);
      if (n != null && n.length > 0) {
        booleanSecure = true;
      }
    }

    if (type === 'csv' || type === 'SHAPE-ZIP') {
      let layer_name = layer.getName();
      if (layer_name === undefined) layer_name = '';
      url =
        onlineResource.replace('wms', 'wfs').replace('wmts/service/', 'wfs') +
        '?REQUEST=GetFeature&service=wfs&version=' +
        config.capabilities_version +
        '&typename=' +
        layer.name;
      url += '&outputformat=' + type;
    } else if (type === 'kml') {
      let layer_name = layer.getName();
      if (layer_name === undefined) layer_name = '';
      let urlGH = config.url_owsseg_wms;
      if (!booleanSecure) urlGH = config.url_wms;
      url = urlGH + '?service=WMS&version=' + config.capabilities_version + '&request=GetMap&layers=' + layer.name;
      url +=
        '&styles=&bbox=244959.380046551,4483181.60679127,526053.117747478,4749728.17845571&width=512&height=485&srs=EPSG:25831&format=application%2Fvnd.google-earth.kml%2Bxml';
    } else if (type === 'GML3') {
      let layer_name = layer.getName();
      if (layer_name === undefined) layer_name = '';
      url = config.url_getGML + '?LAYER=' + layer_name;
    }
    let idExtension;
    if (layer.getExtension() !== undefined) {
      let extension = layer.getExtension();
      idExtension = extension.Id;
    }

    let object_id = feature.values_[idExtension];
    if (object_id === undefined) object_id = '';
    url += '&CQL_FILTER=(' + (idExtension.toUpperCase() === 'ID' ? '"ID"' : idExtension) + '=' + feature.values_[idExtension] + ')';
    if (layer.getExtension() !== undefined) {
      url += '&propertyName=' + generarURLExtension(layer);
    }
    window.open(url);
  };

  obtenirAtributs = () => {
    Object.entries(this.props.info).forEach(([key, value]) => {
      if (key === this.props.nomPunt) {
        this.setState({ toolTip: value });
      }
    });
  };

  closeCard = (e) => {
    e.stopPropagation();
    this.props.removeCard(this.props.id);
  };

  favCheck = () => {
    return this.props.favList.some((fav) => {
      if (fav.type !== 'coords') {
        return isDeepEqual(fav.fav.getProperties(), this.props.feature.getProperties());
      }
      return false;
    });
  };

  editClick = () => {
    this.props.setEditing(true, this.props.layer, 'edit', this.props.feature);
  };

  acceptDelete = () => {
    deleteFeature(this.props.layer, this.props.feature);
    this.props.toggleAlert(false);
    this.props.setEditing(false, this.props.layer);
  };

  deleteClick = () => {
    let id = this.props.info[this.props.layer.getExtension().Id];
    const Component = () => (
      <>
        <Text>
          {getTranslatedKey('deleteFeatureWarn') + id}? {getTranslatedKey('noUndo')}
        </Text>
        <CardEditButtonWrapper>
          <ButtonStyle onClick={() => this.props.toggleAlert(false)}>{getTranslatedKey('cancel')}</ButtonStyle>
          <ButtonStyle eliminar onClick={() => this.acceptDelete()}>
            {getTranslatedKey('delete')}
          </ButtonStyle>
        </CardEditButtonWrapper>
      </>
    );
    this.props.toggleAlert(true, <Component />, 'Atenció', false);
  };

  deleteGeomClick = (e) => {
    e.stopPropagation();
    if (!this.props.isEditing.isEditing) {
      this.props.setEditing('deleteGeom', this.props.layer, 'deleteGeom', this.props.feature);
      this.props.featureOverlay.getSource().clear();
    } else {
      this.props.setEditing(false, this.props.layer);
    }
  };

  render() {
    return (
      <>
        <CardContainer
          id={`point-info-card-${this.props.id}`}
          altura={this.props.altura}
          mobile={window.innerWidth < 768}
          selected={this.props.selected}
          onClick={() => {
            this.props.onClickCard(this.props.id, { layer: this.props.nomCapa, fotos: this.state.photos });
            this.props.featureOverlay.getSource().clear();
            this.props.featureOverlay.getSource().addFeature(this.props.feature);
          }}>
          <CardWrapper id={`point-info-card-wrapper-${this.props.id}`} altura={this.props.altura}>
            <CardHeader id={`point-info-card-header-${this.props.id}`}>
              <ElementTitleWrapper>
                <NomCapa title={this.props.nomCapa} class={'nomCapa' + this.props.nomCapa} fontSizeEnabled={this.props.fontSizeEnabled}>
                  {this.props.nomCapa}
                </NomCapa>
                <ElementTitle
                  title={this.props.featureName}
                  class="toolTipCapa"
                  id={`point-info-card-title-${this.props.id}`}
                  fontSizeEnabled={this.props.fontSizeEnabled}>
                  {this.props.featureName}
                </ElementTitle>
              </ElementTitleWrapper>
              {/* MEJORA CERRAR INFO CARD*/}
              {/* <CloseBtnWrapper onClick={(e) => this.closeCard(e)} title={getTranslatedKey('tancar')} fontSizeEnabled={this.props.fontSizeEnabled}>
                <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
              </CloseBtnWrapper> */}
              <HeaderButtons id={`point-info-card-header-btns-${this.props.id}`}>
                <HeaderBtn>
                  <InfoPuntCardSVG fontSizeEnabled={this.props.fontSizeEnabled} viewBox="0 0 24 24" fill="#c3a12d">
                    <path d="M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z" />
                  </InfoPuntCardSVG>
                </HeaderBtn>
                <HeaderBtn>
                  <InfoPuntCardSVG fontSizeEnabled={this.props.fontSizeEnabled} viewBox="0 0 24 24" fill="#fff">
                    <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                  </InfoPuntCardSVG>
                </HeaderBtn>
              </HeaderButtons>
            </CardHeader>
            <CardBody id={`point-info-card-body-${this.props.id}`}>
              <BodyInfo id={`point-info-card-body-info-${this.props.id}`}>
                <InfoDesc id={`point-info-card-body-desc-${this.props.id}`} fontSizeEnabled={this.props.fontSizeEnabled}>
                  {Object.entries(this.props.info).map(([key, value]) => {
                    // if (key === this.props.layer.getExtension().Id || key === this.props.layer.getExtension().Geometry) return null;
                    let properties = this.props.layer.getProperties();
                    let property = properties.find((property) => property.name === key);
                    let valor = checkUrl(value) ? (
                      <Link target="_blank" rel="noreferrer" href={replaceHTTPWithHTTPS(value)}>
                        {urlNameSelector(value)}
                        <SVGNewTab id="NewTab" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                          <g>
                            <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                            <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                          </g>
                        </SVGNewTab>
                      </Link>
                    ) : (
                      value
                    );
                    if (
                      (this.props.isRaster || property !== undefined) &&
                      key !== 'bbox' &&
                      key !== 'geometry' &&
                      value &&
                      value.toString().trim() !== ''
                    ) {
                      return (
                        <Parametre
                          title={this.props.isRaster ? key : property.alias + ': ' + value}
                          class="atributeElement"
                          fontSizeEnabled={this.props.fontSizeEnabled}>
                          <NomParametre>
                            {this.props.isRaster ? <b>{getTranslatedKey('value') + ': '}</b> : <b>{property.alias + ': '}</b>}
                            {valor}
                          </NomParametre>
                        </Parametre>
                      );
                    } else {
                      return null;
                    }
                  })}
                </InfoDesc>
              </BodyInfo>
            </CardBody>
            <CardFooter id={`point-info-card-footer-${this.props.id}`}>
              {!this.props.isRaster && (
                <>
                  <LeftButtons id={`point-info-card-footer-left-btns  ${this.props.id}`}>
                    <InfoCardButton
                      id="go-to-element-btn"
                      className="go-to-element-btn"
                      title={getTranslatedKey('zoomElement')}
                      onClick={() => zoomMapToBBOX(this.props.map, this.props.bbox, this.props.altura)}
                      onMouseEnter={() => this.setState({ isLocationHovered: true })}
                      onMouseLeave={() => this.setState({ isLocationHovered: false })}>
                      <InfoPuntCardSVG
                        fontSizeEnabled={this.props.fontSizeEnabled}
                        space="preserve"
                        fill={window.innerWidth > 768 ? (this.state.isLocationHovered ? '#febf00' : '#fff') : 'white'}
                        paddingBottom="2px"
                        viewBox="0 0 32 32">
                        <path d="M28.5259,3.1494a1,1,0,0,0-.9732-.0439L20,6.8818,12.4473,3.1055a1.0008,1.0008,0,0,0-.8946,0l-8,4A1,1,0,0,0,3,8V28a1,1,0,0,0,1.4473.8945L12,25.1182l3.5527,1.7763a1,1,0,0,0,.8946-1.789L13,23.3818V8a1,1,0,0,0-2,0V23.3818l-6,3V8.6182l7-3.5,7,3.5V14a1,1,0,0,0,2,0V8.6182l6-3V18a1,1,0,0,0,2,0V4A1,1,0,0,0,28.5259,3.1494Z" />
                        <path d="M26.167,24.7529a5.015,5.015,0,1,0-1.4141,1.4141l2.54,2.54a1,1,0,0,0,1.414-1.414ZM19,22a3,3,0,1,1,3,3A3.0033,3.0033,0,0,1,19,22Z" />
                      </InfoPuntCardSVG>
                    </InfoCardButton>
                    {this.state.photos.length > 0 && (
                      <InfoCardButton
                        className="photo-button"
                        onClick={() => this.photoClick()}
                        title={getTranslatedKey('modalGaleria')}
                        onMouseEnter={() => this.setState({ isPhotoHovered: true })}
                        onMouseLeave={() => this.setState({ isPhotoHovered: false })}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill={window.innerWidth > 768 ? (this.state.isPhotoHovered ? '#febf00' : 'white') : 'white'}
                          version="1.1"
                          id="Capa_1"
                          x="0px"
                          y="0px"
                          width="24"
                          viewBox="0 0 548.176 548.176">
                          <g>
                            <g>
                              <path d="M534.75,68.238c-8.945-8.945-19.694-13.417-32.261-13.417H45.681c-12.562,0-23.313,4.471-32.264,13.417    C4.471,77.185,0,87.936,0,100.499v347.173c0,12.566,4.471,23.318,13.417,32.264c8.951,8.946,19.702,13.419,32.264,13.419h456.815    c12.56,0,23.312-4.473,32.258-13.419c8.945-8.945,13.422-19.697,13.422-32.264V100.499    C548.176,87.936,543.699,77.185,534.75,68.238z M511.623,447.672c0,2.478-0.899,4.613-2.707,6.427    c-1.81,1.8-3.952,2.703-6.427,2.703H45.681c-2.473,0-4.615-0.903-6.423-2.703c-1.807-1.813-2.712-3.949-2.712-6.427V100.495    c0-2.474,0.902-4.611,2.712-6.423c1.809-1.803,3.951-2.708,6.423-2.708h456.815c2.471,0,4.613,0.905,6.42,2.708    c1.801,1.812,2.707,3.949,2.707,6.423V447.672L511.623,447.672z" />
                              <path d="M127.91,237.541c15.229,0,28.171-5.327,38.831-15.987c10.657-10.66,15.987-23.601,15.987-38.826    c0-15.23-5.333-28.171-15.987-38.832c-10.66-10.656-23.603-15.986-38.831-15.986c-15.227,0-28.168,5.33-38.828,15.986    c-10.656,10.66-15.986,23.601-15.986,38.832c0,15.225,5.327,28.169,15.986,38.826C99.742,232.211,112.683,237.541,127.91,237.541z    " />
                              <polygon points="210.134,319.765 164.452,274.088 73.092,365.447 73.092,420.267 475.085,420.267 475.085,292.36 356.315,173.587       " />
                            </g>
                          </g>
                        </svg>
                      </InfoCardButton>
                    )}
                    {displayComponents.preferits && (
                      <FavButton
                        title={getTranslatedKey('addToFav')}
                        onMouseEnter={() => this.setState({ isFavHovered: true })}
                        onMouseLeave={() => this.setState({ isFavHovered: false })}
                        onClick={() => this.props.addToFav(this.props.feature, 'feature', this.props.featureName, this.props.layer)}>
                        {this.favCheck() ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="favFill"
                            fill="#febf00"
                            enable-background="new 0 0 511.992 511.992"
                            viewBox="0 0 511.992 511.992"
                            width="22">
                            <path d="m510.616 196.062c-3.944-12.141-15.728-20.486-32.329-22.897l-131.649-19.132-58.875-119.294c-7.425-15.043-19.003-23.671-31.767-23.671s-24.342 8.628-31.766 23.671l-58.873 119.293-131.651 19.132c-16.602 2.411-28.385 10.757-32.33 22.896-3.944 12.14.684 25.817 12.695 37.526l95.263 92.856-22.489 131.121c-2.957 17.247 2.065 27.561 6.8 33.176 5.538 6.568 13.617 10.186 22.749 10.186 6.904 0 14.257-2.024 21.85-6.018l117.752-61.907 117.752 61.905c7.595 3.993 14.947 6.019 21.852 6.019h.002c9.133 0 17.212-3.617 22.75-10.186 4.734-5.614 9.757-15.929 6.799-33.177l-22.492-131.118 95.262-92.855c12.013-11.709 16.64-25.387 12.695-37.526z" />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="favStandard"
                            fill={window.innerWidth > 768 ? (this.state.isFavHovered ? '#febf00' : 'white') : 'white'}
                            width="24"
                            viewBox="0 0 32 32">
                            <path d="m7.998 30.544c-.415 0-.827-.129-1.176-.382-.589-.428-.899-1.143-.809-1.866l.98-7.839-5.399-5.766c-.498-.532-.668-1.293-.442-1.986.225-.692.81-1.208 1.524-1.345l7.759-1.49 3.813-6.918c.353-.638 1.023-1.035 1.752-1.035s1.399.396 1.751 1.034 3.814 6.918 3.814 6.918l7.758 1.49c.715.137 1.3.653 1.524 1.345.226.693.056 1.454-.441 1.986l-5.401 5.766.98 7.839c.091.723-.22 1.438-.809 1.866-.591.429-1.366.501-2.025.192l-7.152-3.354-7.152 3.354c-.271.127-.561.189-.85.189zm7.999-26.631-3.812 6.923c-.288.521-.788.885-1.373.998l-7.76 1.49 5.4 5.766c.408.436.6 1.024.525 1.616l-.98 7.838 7.152-3.354c.542-.253 1.16-.252 1.698 0l7.153 3.355-.98-7.839c-.074-.591.117-1.18.525-1.615l5.4-5.766-7.759-1.49c-.586-.113-1.086-.477-1.374-.998l-3.817-6.923z" />
                          </svg>
                        )}
                      </FavButton>
                    )}
                    {displayComponents.edicio && this.props.layer.getExtension()?.Editable === 'true' && (
                      <>
                        <InfoCardButton
                          className="element-edit-button"
                          onClick={() => this.editClick()}
                          title={getTranslatedKey('editFeature')}
                          onMouseEnter={() => this.setState({ isEditHovered: true })}
                          onMouseLeave={() => this.setState({ isEditHovered: false })}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            id="editando"
                            fill={this.state.isEditHovered ? '#febf00' : 'white'}
                            width="22"
                            viewBox="0 0 512 512">
                            <path d="M405.3,257c-11.8,0-21.3,9.6-21.3,21.3V449c0,11.8-9.6,21.3-21.3,21.3H64c-11.8,0-21.3-9.6-21.3-21.3V150.3  c0-11.8,9.6-21.3,21.3-21.3h170.7c11.8,0,21.3-9.6,21.3-21.3c0-11.8-9.5-21.3-21.3-21.3H64c-35.3,0-64,28.7-64,64V449  c0,35.3,28.7,64,64,64h298.7c35.3,0,64-28.7,64-64V278.3C426.7,266.5,417.1,257,405.3,257z" />
                            <g>
                              <path d="M495.7,20.6c-21.9-21.8-57.4-21.8-79.3,0L403,34.1l79.3,79.3l13.4-13.4C517.4,78,517.4,42.6,495.7,20.6z" />
                              <path d="M109.5,327.5c-0.8,0.9-1.5,1.9-1.9,3.1L73.5,432.9c-1.4,4.1,0.8,8.6,4.9,10c1.6,0.6,3.4,0.6,5,0l102.3-34.1   c1.1-0.4,2.2-1,3.1-1.9l77.8-77.8L397.7,198l73.5-73.4l-79.3-79.3L109.5,327.5z" />
                            </g>
                          </svg>
                        </InfoCardButton>
                        {this.props.feature.getGeometry().getCoordinates().length > 1 && (
                          <InfoCardButton
                            className="geom-delete-button"
                            onClick={(e) => this.deleteGeomClick(e)}
                            title={getTranslatedKey('deleteGeom')}
                            onMouseEnter={() => this.setState({ isDeleteGeomHovered: true })}
                            onMouseLeave={() => this.setState({ isDeleteGeomHovered: false })}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              id="glipy"
                              width="22"
                              fill={this.props.isEditing?.type === 'deleteGeom' ? '#febf00' : this.state.isDeleteGeomHovered ? '#febf00' : 'white'}
                              viewBox="0 0 64 64">
                              <g>
                                <path d="M61.3,3C58.1-0.2,53-0.2,49.9,3L48,4.9l11.4,11.4l1.9-1.9C64.4,11.2,64.4,6.1,61.3,3z" />
                                <path d="M45.5,30.1c-8.3-3.5-17.7,4-16.1,12.9c2.7,14.2,23.1,12.7,23.6-1.9C53,36.3,50,31.9,45.5,30.1z M48,42.8H34.6   c-0.8,0-1.5-0.8-1.5-1.7c0-0.9,0.7-1.7,1.5-1.7H48c0.8,0,1.4,0.8,1.4,1.7C49.4,42,48.8,42.8,48,42.8z" />
                                <path d="M5.8,47c-0.1,0.1-0.2,0.3-0.3,0.4L0.7,62.1c-0.2,0.6,0.1,1.2,0.7,1.4c0.2,0.1,0.5,0.1,0.7,0l14.7-4.9   c0.2-0.1,0.3-0.1,0.4-0.3l11.2-11.2c-5.7-11.9,7-24.6,18.8-18.8l10.5-10.5L46.4,6.5L5.8,47z" />
                              </g>
                            </svg>
                          </InfoCardButton>
                        )}
                        <InfoCardButton
                          className="element-delete-button"
                          onClick={() => this.deleteClick()}
                          title={getTranslatedKey('deleteFeature')}
                          onMouseEnter={() => this.setState({ isDeleteHovered: true })}
                          onMouseLeave={() => this.setState({ isDeleteHovered: false })}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            id="Capa_1"
                            width="24"
                            x="0px"
                            y="0px"
                            viewBox="0 0 512 512"
                            fill={this.state.isDeleteHovered ? '#febf00' : 'white'}>
                            <path
                              d="M130.3,462.6c-9.5,0-17.6-3.4-24.3-10.1c-6.7-6.7-10.1-14.9-10.1-24.3V109.7c0-4.8-3.9-8.6-8.6-8.6H81
                                c-4.8,0-8.6-3.9-8.6-8.6V75.2c0-4.8,3.9-8.6,8.6-8.6h90.7c4.8,0,8.6-3.9,8.6-8.6v0c0-4.8,3.9-8.6,8.6-8.6h134.3
                                c4.8,0,8.6,3.9,8.6,8.6v0c0,4.8,3.9,8.6,8.6,8.6H431c4.8,0,8.6,3.9,8.6,8.6v17.2c0,4.8-3.9,8.6-8.6,8.6h-6.3c-4.8,0-8.6,3.9-8.6,8.6
                                v318.5c0,9.2-3.4,17.2-10.3,24.1c-6.9,6.9-14.9,10.3-24.1,10.3H130.3z M381.7,101H130.3v327.1h251.4V101z M208.4,378.8L208.4,378.8
                                c9.5,0,17.2-7.7,17.2-17.2V167c0-9.5-7.7-17.2-17.2-17.2h0c-9.5,0-17.2,7.7-17.2,17.2v194.6C191.1,371.1,198.9,378.8,208.4,378.8z
                                M303.6,378.8L303.6,378.8c9.5,0,17.2-7.7,17.2-17.2V167c0-9.5-7.7-17.2-17.2-17.2h0c-9.5,0-17.2,7.7-17.2,17.2v194.6
                                C286.4,371.1,294.1,378.8,303.6,378.8z M130.3,101v327.1V101z"></path>
                          </svg>
                        </InfoCardButton>
                      </>
                    )}
                  </LeftButtons>
                  {displayComponents.descarregaInfoPunt && (
                    <RightButtons id={`point-info-card-footer-right-btns${this.props.id}`}>
                      <InfoCardButton
                        id="exportar-gml-btn"
                        className="exportar-feature"
                        title={getTranslatedKey('exportGML')}
                        onMouseEnter={() => this.setState({ isGMLHovered: true })}
                        onMouseLeave={() => this.setState({ isGMLHovered: false })}
                        onClick={() => this.construirURLExport(this.props.feature, this.props.layer, 'GML3')}>
                        <InfoPuntCardSVG
                          fontSizeEnabled={this.props.fontSizeEnabled}
                          viewBox="0 0 512 512"
                          space="preserve"
                          fill={window.innerWidth > 768 ? (this.state.isGMLHovered ? '#febf00' : 'white') : 'white'}>
                          <path d="M451.9,244.6h-4.6v-98.9c0-3.3-1.3-6.4-3.8-8.6L330.9,24.6c-2.2-2.4-5.4-3.8-8.6-3.8H104.5  c-22.1,0-40,17.9-40,40v184h-4.6c-22.1,0-40,17.9-40,40v104c0,22.1,17.9,40,40,40h4.6v24c0,22.1,17.9,40,40,40h302.9  c22.1,0,40-17.9,40-40v-24h4.6c22.1,0,40-17.9,40-40v-104c0.1-22.1-17.7-40.1-39.8-40.2C452.1,244.6,452,244.6,451.9,244.6  L451.9,244.6z M334.2,61.6l72,72h-72V61.6z M88.5,60.6c0-8.8,7.2-16,16-16h205.8v101.1c0,6.6,5.4,12,12,12h101.1v86.9H88.5V60.6z   M423.3,452.6c0,8.8-7.2,16-16,16H104.5c-8.8,0-16-7.2-16-16v-24h334.9v24H423.3z M174.7,329.4v61.1h-18.3  c-1.5-4.5-3.1-8.3-4.9-11.4c-7.6,8.8-18.7,13.2-33.6,13.2c-15.7,0-28.6-4.9-38.7-14.7s-15.2-23.1-15.2-40c0-16.3,4.9-30,14.7-41.2  c9.7-11.2,24.3-16.6,43.7-16.6c14.5,0,26.2,3.3,35.1,10s14.6,16,17.2,28.1l-36.2,3.2c-1.8-11.4-7.4-17.1-16.7-17.1  c-12.2,0-18.4,10.4-18.4,31.3c0,12.6,2,21,5.9,25s8.7,6.1,14.2,6.1c4.5,0,8.4-1.2,11.5-3.7c3.2-2.5,4.7-5.8,4.9-10.1h-20.2v-23.3  H174.7z M334.1,281.3v109.2h-34.8v-78.1l-22.5,78.1H253l-23.4-78.1v78.1h-28V281.3h48.9l17.7,58l16.8-58H334.1z M447.9,363.7v26.8  h-85.4V281.3h37.4v82.3H447.9z" />
                        </InfoPuntCardSVG>
                      </InfoCardButton>
                      <InfoCardButton
                        id="exportar-csv-btn"
                        className="exportar-feature"
                        title={getTranslatedKey('exportCSV')}
                        onMouseEnter={() => this.setState({ isCSVHovered: true })}
                        onMouseLeave={() => this.setState({ isCSVHovered: false })}
                        onClick={() => this.construirURLExport(this.props.feature, this.props.layer, 'csv')}>
                        <InfoPuntCardSVG
                          fontSizeEnabled={this.props.fontSizeEnabled}
                          viewBox="0 0 512 512"
                          space="preserve"
                          fill={window.innerWidth > 768 ? (this.state.isCSVHovered ? '#febf00' : 'white') : 'white'}>
                          <path d="M452.4,244.6h-4.6v-98.9c0-3.3-1.3-6.4-3.8-8.6L331.4,24.6c-2.2-2.4-5.4-3.8-8.6-3.8H105c-22.1,0-40,17.9-40,40  v184h-4.6c-22.1,0-40,17.9-40,40v104c0,22.1,17.9,40,40,40H65v24c0,22.1,17.9,40,40,40h302.9c22.1,0,40-17.9,40-40v-24h4.6  c22.1,0,40-17.9,40-40v-104c0.1-22.1-17.7-40.1-39.8-40.2C452.6,244.6,452.5,244.6,452.4,244.6L452.4,244.6z M334.7,61.6l72,72h-72  V61.6z M89,60.6c0-8.8,7.2-16,16-16h205.8v101.1c0,6.6,5.4,12,12,12h101.1v86.9H89V60.6z M423.8,452.6c0,8.8-7.2,16-16,16H105  c-8.8,0-16-7.2-16-16v-24h334.9v24H423.8z M148.7,350.7l35.6,1.9c-1.7,14-7.4,24.6-17.3,32.1c-9.8,7.4-21.9,11.1-36.3,11.1  c-17.2,0-31.2-5.1-41.8-15.3C78.3,370.1,73,356,73,338c0-17.8,5.1-32.3,15.1-43.2c10-10.9,24.1-16.5,42.1-16.5  c16.8,0,29.7,4.2,38.7,12.5c9,8.3,14.1,19.4,15.3,33.2l-36.4,1.7c0-7.7-1.6-13.1-4.8-16.5c-3.2-3.3-7.1-5.1-11.5-5.1  c-12.3,0-18.4,11-18.4,33.2c0,12.4,1.6,20.8,4.8,25.2c3.2,4.5,7.7,6.7,13.5,6.7C141.7,369.5,147.5,363.2,148.7,350.7z M194.1,361.2  l36.3-5.8c3.1,9.2,10.9,13.7,23.5,13.7c9.8,0,14.7-2.4,14.7-7.1c0-2.5-1.1-4.3-3.3-5.7c-2.2-1.4-6.3-2.6-12.1-3.6  c-22.3-3.8-36.6-8.8-42.9-15c-6.3-6.2-9.5-13.5-9.5-21.8c0-10.8,4.6-19.7,13.6-26.7c9-7.2,22.2-10.6,39.2-10.6  c25.9,0,42.9,9.3,51.2,28l-32.3,8.8c-3.3-7.7-10.1-11.4-20.4-11.4c-8.5,0-12.7,2.4-12.7,7.1c0,2.1,1,3.7,2.8,5  c2,1.1,5.7,2.2,11.1,3.3c15.2,2.8,26,5.4,32.4,7.7c6.4,2.2,11.8,6.1,16,11.4c4.2,5.3,6.4,11.8,6.4,18.9c0,11.5-5.2,20.8-15.6,28  c-10.4,7.2-24.1,10.8-41.1,10.8C220.4,395.9,201.4,384.3,194.1,361.2z M439,280.2l-39.5,113.9h-39.7l-41.2-113.9h41.1l20.1,62  c1.4,3.7,2.6,7.3,3.6,10.9l23.5-72.9H439z" />
                        </InfoPuntCardSVG>
                      </InfoCardButton>
                      <InfoCardButton
                        id="exportar-kml-btn"
                        className="exportar-feature"
                        title={getTranslatedKey('exportKML')}
                        onMouseEnter={() => this.setState({ isKMLHovered: true })}
                        onMouseLeave={() => this.setState({ isKMLHovered: false })}
                        onClick={() => this.construirURLExport(this.props.feature, this.props.layer, 'kml')}>
                        <InfoPuntCardSVG
                          fontSizeEnabled={this.props.fontSizeEnabled}
                          viewBox="0 0 512 512"
                          space="preserve"
                          fill={window.innerWidth > 768 ? (this.state.isKMLHovered ? '#febf00' : 'white') : 'white'}>
                          <path d="M452,244h-4.6v-98.9c0-3.3-1.3-6.4-3.8-8.6L331,24c-2.2-2.4-5.4-3.8-8.6-3.8H104.6c-22.1,0-40,17.9-40,40v184  H60c-22.1,0-40,17.9-40,40v104c0,22.1,17.9,40,40,40h4.6v24c0,22.1,17.9,40,40,40h302.9c22.1,0,40-17.9,40-40v-24h4.6  c22.1,0,40-17.9,40-40v-104c0.1-22.1-17.7-40.1-39.8-40.2C452.2,244,452.1,244,452,244L452,244z M334.3,61l72,72h-72V61z M88.6,60  c0-8.8,7.2-16,16-16h205.8v101.1c0,6.6,5.4,12,12,12h101.1V244H88.6V60z M423.4,452c0,8.8-7.2,16-16,16H104.6c-8.8,0-16-7.2-16-16  v-24h334.9v24H423.4z M169.9,397h-45.4l-23.3-45.8l-14,17.8v27.9H48V275.7h39.1v50l37.3-50h37.3l-34.1,44.4L169.9,397z M335.8,275.8  V397h-38.6v-86.6l-25,86.6h-26.3l-25.9-86.6V397h-31.1V275.8h54.2l19.6,64.4l18.7-64.4H335.8z M462,367.2V397h-94.8V275.8h41.5v91.4  H462z" />
                        </InfoPuntCardSVG>
                      </InfoCardButton>
                      <InfoCardButton
                        id="exportar-shp-btn"
                        className="exportar-feature"
                        title={getTranslatedKey('exportSHP')}
                        onMouseEnter={() => this.setState({ isSHPHovered: true })}
                        onMouseLeave={() => this.setState({ isSHPHovered: false })}
                        onClick={() => this.construirURLExport(this.props.feature, this.props.layer, 'SHAPE-ZIP')}>
                        <InfoPuntCardSVG
                          fontSizeEnabled={this.props.fontSizeEnabled}
                          viewBox="0 0 512 512"
                          space="preserve"
                          fill={window.innerWidth > 768 ? (this.state.isSHPHovered ? '#febf00' : 'white') : 'white'}>
                          <path d="M452.4,244.6h-4.6v-98.9c0-3.3-1.3-6.4-3.8-8.6L331.4,24.6c-2.2-2.4-5.4-3.8-8.6-3.8H105c-22.1,0-40,17.9-40,40  v184h-4.6c-22.1,0-40,17.9-40,40v104c0,22.1,17.9,40,40,40H65v24c0,22.1,17.9,40,40,40h302.9c22.1,0,40-17.9,40-40v-24h4.6  c22.1,0,40-17.9,40-40v-104c0.1-22.1-17.7-40.1-39.8-40.2C452.6,244.6,452.5,244.6,452.4,244.6L452.4,244.6z M334.7,61.6l72,72h-72  V61.6z M89,60.6c0-8.8,7.2-16,16-16h205.8v101.1c0,6.6,5.4,12,12,12h101.1v86.9H89V60.6z M423.8,452.6c0,8.8-7.2,16-16,16H105  c-8.8,0-16-7.2-16-16v-24h334.9v24H423.8z M60,361.4l37-5.9c3.2,9.4,11.1,14,24,14c10,0,15-2.4,15-7.2c0-2.5-1.1-4.4-3.4-5.8  c-2.3-1.4-6.4-2.7-12.4-3.7c-22.8-3.9-37.4-9-43.9-15.3c-6.4-6.3-9.7-13.8-9.7-22.2c0-11,4.7-20.1,13.9-27.3  c9.2-7.3,22.6-10.9,40.1-10.9c26.4,0,43.9,9.5,52.3,28.6l-33,9c-3.4-7.8-10.4-11.6-20.9-11.6c-8.7,0-13,2.4-13,7.2  c0,2.1,1,3.8,2.9,5.1c2,1.1,5.8,2.3,11.4,3.4c15.5,2.9,26.5,5.6,33.1,7.8c6.6,2.3,12,6.2,16.3,11.6c4.3,5.4,6.6,12,6.6,19.3  c0,11.8-5.3,21.2-15.9,28.6c-10.6,7.3-24.7,11-42,11C86.9,396.8,67.3,385,60,361.4z M310.5,278.7V395h-39.8v-45.3h-30.5V395h-39.8  V278.7h39.8v42.7h30.5v-42.7H310.5z M382.2,352.8V395h-40.5V278.7h55.4c13.8,0,24.3,1.4,31.5,4.3c7.2,2.8,12.9,7.2,17.1,13  c4.2,5.8,6.3,12.4,6.3,19.7c0,11.1-4.3,20-12.9,26.8c-8.6,6.8-20.1,10.2-34.5,10.2H382.2z M381.6,327.7h13.3  c11.8,0,17.6-3.9,17.6-11.6c0-7.3-5.4-10.9-16.3-10.9h-14.7v22.5H381.6z" />
                        </InfoPuntCardSVG>
                      </InfoCardButton>
                    </RightButtons>
                  )}
                </>
              )}
            </CardFooter>
          </CardWrapper>
        </CardContainer>
      </>
    );
  }
}
